function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 594",
  style: {
    fill: "transparent",
    stroke: "#ccc"
  }
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  stroke: "none",
  rx: 8,
  style: {
    stroke: "none"
  }
}), /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 15,
  x: 0.5,
  y: 0.5,
  rx: 7.5,
  style: {
    fill: "none"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M2636.25-603.25v-4a.75.75 0 0 1 .75-.75.75.75 0 0 1 .75.751v4a.75.75 0 0 1-.75.751.75.75 0 0 1-.75-.752M2636-610a1 1 0 0 1 1-1 1 1 0 0 1 1 1 1 1 0 0 1-1 1 1 1 0 0 1-1-1",
  "data-name": "Union 62",
  style: {
    fill: "#ccc"
  },
  transform: "translate(-2629 615)"
}));
export default SvgIconInfo;